module.exports = __webpack_public_path__ + "static/media/multi-icon-1.b90d1e33.svg";